import React, { useEffect, useState } from "react";
import { Pagination } from "@mui/material";
import PaginatedTable from "../../components/paginatedTable";

export default function UserPayments({ userId, companyId }) {
  const [payments, setPayments] = useState([]);
  const [paymentPage, setPaymentPage] = useState(1);
  const [paymentTotalPages, setPaymentTotalPages] = useState(1);

  const paymentColumns = [
    {
      field: 'planName',
      headerName: 'Plan Name',
      width: 200,
    },
    {
      field: 'planDuration',
      headerName: 'Duration (days)',
      width: 200,
    },
    {
      field: 'amount',
      headerName: 'Amount (€)',
      width: 200,
      renderCell: (params) => (
        <span>{(parseInt(params.value) / 100).toFixed(2)}</span>
      )
    },
    {
      field: 'created_at',
      headerName: 'Date',
      width: 200,
      renderCell: (params) => (
        <span>{new Date(params.value).toLocaleDateString("en-EN", {
          year: "numeric",
          month: "short",
          day: "numeric"
        })}</span>
      )
    },
  ];

  const fetchPayments = async (page = 1) => {
    try {
      const token = localStorage.getItem("token");
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/payments?user=${userId}&page=${page}&per_page=15`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const result = await response.json();
      const formattedData = result.data.map(item => ({
        id: item.id,
        planName: item.metadata?.planName || "N/A",
        planDuration: item.metadata?.planDuration || "N/A",
        amount: item.amount,
        created_at: item.created_at
      }));

      setPayments(formattedData);
      setPaymentPage(result.current_page);
      setPaymentTotalPages(result.last_page);
    } catch (err) {
      console.error("Error fetching user payments:", err);
    }
  };

  useEffect(() => {
    if (userId) fetchPayments(paymentPage);
  }, [userId, paymentPage]);

  return (
    <div className="flex flex-col gap-6">
      <h2 className="text-3xl font-semibold">User Payments</h2>
      <PaginatedTable
        header={paymentColumns}
        items={payments}
        hideFooterPagination={true}
      />
      {paymentTotalPages > 1 && (
        <div className="flex justify-center mt-6">
          <Pagination
            count={paymentTotalPages}
            page={paymentPage}
            onChange={(event, value) => setPaymentPage(value)}
            color="primary"
          />
        </div>
      )}
    </div>
  );
}
